import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const NewProductDevelopment = () => {
    //const location = useLocation();
    //const pathSegments = location.pathname.split('/');
    //const loc = pathSegments.length === 3 ? `in ${capitalize(pathSegments[pathSegments.length - 1])}` : '';

    //const pageTitle = `Best New Product Development Process Software ${loc} | ERP Systems | Business Management Solutions - Tejaxo Software`;
    //const metaDescription = `Tejaxo Software is a High Rated Indian New Product Development Process Software ${loc}, providing award-winning Enterprise Resource Planning (ERP) software for Customer Portal System, business management solutions, services and support.`;
    //const metaKeywords = `Tejaxo New Product Development Process Software ${loc}, Tejaxo New Product Development Process Software`;

    //document.title = pageTitle;
    //document.querySelector('meta[name="description"]').setAttribute('content', metaDescription);
    //document.querySelector('meta[name="keywords"]').setAttribute('content', metaKeywords);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                <div className="row">
                        <h2 className="mkdf-page-title entry-title">
                            New Product Development Process {state.condText}
                    </h2>
                </div>
                <br />
                <div className="row">
                    <div className="sqs-block-content">
                        <p>
                            <strong>New Product Development (NPD) processes</strong> are all about getting a great product out the door and loved by the market. The process of developing the new product needs to focus on that delivery outcome as it�s all about end results.
                        </p>
                        <p>Do you make your money from your NPD output?</p>
                        <p>Does your NPD output bring value to your brand?</p>
                        <p>Yes? Then keep reading.</p>
                        <p>Your deployed products are your lifeline to your business brand value and financial valuation. Think about your competition. Ask if you can stay in the game.</p>

                        <ul>
                            <li>Do your NPD processes today include best practice steps that drive value?</li>
                            <li>Are these repeatable and scalable?</li>
                            <li>Do they constantly improve in real time?</li>
                        </ul>

                        <p>Pie is not just a visual project and process application; it�s more than that. It�s a lifeline platform for your new product development lifecycle. Any tool can check off what is done. Tejaxo helps you easily define your NPD project process ingredients and steps on how to build and deploy the most amazing value to your end customers.</p>

                        <h3>Get fast-to-market Value delivery</h3>
                        <p>Speed is one thing. Getting there fast is only half the journey. The important key here is �value.� What business value are you delivering fast to market? Tejaxo is designed to help our customers reduce pain and increase team engagement. Less pain and happier people who understand how to build and deliver your products will quickly get you 100% of the way there.</p>

                        <ul>
                            <li>Execute a well-defined new product development strategy that includes the how-to steps for all known processes. In Pie, these are your �Recipe� ingredients.</li>
                            <li>Improve consistency and predictability with repeatable Tejaxo recipes that your teams improve over time.</li>
                            <li>Make better timeline decisions and understand time-to-market milestones with Tejaxo progress reporting.</li>
                            <li>Reduce the risk of delivery failure when teams collaborate and engage with the Tejaxo Post features made specifically for identifying and solving issues and risks.</li>
                            <li>Leverage the Tejaxo Ideas Post feature to highlight team members� creative solutions to improve both the new product being developed and its NPD process.</li>
                            <li>Always improve your NPD processes and ensure they drive quality end results. This is done with updating your NPD Tejaxo recipes.</li>
                        </ul>

                        <h3>Process � For the known stuff</h3>
                        <p>A new product development process is a sequence of <strong>known</strong> steps typical with most NPD projects. This includes all the planning, discovery, market analysis, design, etc., where each may require a phase gate for approval before moving to the next phase. Tejaxo provides a visual phase gate process approach with <strong>Pie Slices</strong> and <strong>Pie Process Box</strong> features.</p>

                        <h3>Agile � For the unknown stuff</h3>
                        <p>What about when your NPD projects are full of <strong>unknown</strong> work that may need to be done? This is common when developing a new product that requires a cycle of prototyping or a unique change in execution. This is when an agile approach is helpful, combining your known NPD methodologies with unknown tasks that need discovery along the way.</p>

                        <p>You may have heard of �Agile� for iterative development. This includes the term �scrum,� where a small team identifies, selects, discusses, and develops targeted features. The term �sprint� is an iterative cycle of time for implementing scrums with results that present new prototypes or parts of your overall product.</p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );

  
};

export default NewProductDevelopment;
